<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!--  -->
<template>
  <!-- <div id="simple-calendar-app"> -->
  <!-- <div class="vx-card no-scroll-content"> -->
  <vx-card style="margin-top:0px;border:none;overflow:hidden">
    <iframe :src="moduleUrl" title="External Module" id="external-feature" frameborder="0"
      style="overflow:hidden;height:100vh;width:100%" height="100%" width="100%"></iframe>
  </vx-card>
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import { getApplicationLocalStorageItem } from '../../helpers';


export default {
  data() {
    return {
      // moduleUrl: atob(this.$route.params.url)
      moduleUrl: ''
    }
  },
  watch: {
    $route(to, from) {
      this.moduleUrl = this.decryptURL(to.params.url)
      // react to route changes...
    }
  },
  computed: {

  },
  methods: {
    decryptURL(url) {
      let decryptedURL = decodeURIComponent(atob(url))
      if (decryptedURL.includes('$user_id')) {
        const user = getApplicationLocalStorageItem('user');
        if (user) {
          decryptedURL = decryptedURL.replace('$user_id', JSON.parse(user).hash)
        }
      }
      return decryptedURL
    }
  },
  components: {

  },
  created() {
    this.moduleUrl = this.decryptURL(this.$route.params.url);
  },
  beforeDestroy() {

  },
  mounted() {
    setTimeout(() => {
      let frame = document.getElementById('external-feature').contentWindow
      frame.postMessage('auth', '*')
    }, 1000)
  }
}

</script>


<style lang="scss"></style>
